import { useCallback, useState } from 'react';

import { TabType } from '@/components/Types';

export const useHandleChangesTabs = (defaultTab?: TabType) => {
  const [tab, setTab] = useState<TabType>(defaultTab ?? 0);

  const handleTabChanges = useCallback((tab: TabType) => {
    setTab(tab);
  }, []);

  return {
    handleTabChanges,
    tab,
  };
};
